import { render, staticRenderFns } from "./StrategyDetailPanel.vue?vue&type=template&id=33aa6ae8&scoped=true"
import script from "./StrategyDetailPanel.vue?vue&type=script&lang=js"
export * from "./StrategyDetailPanel.vue?vue&type=script&lang=js"
import style0 from "./StrategyDetailPanel.vue?vue&type=style&index=0&id=33aa6ae8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e128dc07b65f661f3a32bbc83dd42e36/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33aa6ae8",
  null
  
)

export default component.exports